import React from 'react';

import { ViewEntityHeader } from 'components/entityViewer/ViewEntityHeader';
import {
    getTransferNumberDisplay,
    getTransferStatusDisplay,
} from 'components/warehouse/components/fcTransfers/fcTransferDisplayUtils';
import { Badge } from 'shadcn/components/ui/Badge';
import { Button } from 'shadcn/components/ui/Button';

/**
 * Accept Transfer page header: back link, title, transfer status, and primary save action slot.
 *
 * @param {Object} props
 * @param {string | import('react-router-dom').To} props.backHref
 * @param {string} [props.backLabel='Back to FC Transfers']
 * @param {Object} [props.backLinkProps]
 * @param {Record<string, unknown> | null} [props.transfer=null]
 * @param {React.ReactNode} [props.saveTransferAction] - When omitted, a disabled Save Transfer control is shown (finalize wired in a later ticket).
 */
export function AcceptTransferHeader({
    backHref,
    backLabel = 'Back to FC Transfers',
    backLinkProps,
    saveTransferAction,
    transfer = null,
}) {
    const transferNumber = getTransferNumberDisplay(transfer);
    const statusLabel = getTransferStatusDisplay(transfer);

    const entityIdentificationComponent = (
        <div className="flex w-full min-w-0 flex-wrap items-start gap-3 lg:items-center">
            <div className="flex min-w-0 flex-wrap items-center gap-3">
                <h1 className="text-2xl font-semibold tracking-tight text-foreground">
                    Accept Transfer # {transferNumber}
                </h1>
                <Badge variant="outline" className="shrink-0 font-normal">
                    {statusLabel}
                </Badge>
            </div>
            <div className="ml-auto flex shrink-0 items-center gap-2">
                {saveTransferAction ?? (
                    <Button
                        type="button"
                        variant="default"
                        size="sm"
                        disabled
                        title="Save Transfer will finalize the receipt once the backend and mutation are wired."
                    >
                        Save Transfer
                    </Button>
                )}
            </div>
        </div>
    );

    return (
        <ViewEntityHeader
            backHref={backHref}
            backLabel={backLabel}
            backLinkProps={backLinkProps}
            entityIdentificationComponent={entityIdentificationComponent}
        />
    );
}

AcceptTransferHeader.displayName = 'AcceptTransferHeader';
